import React from 'react';
import { LandingPage } from './pages/LandingPage';
import { CheckoutPage } from './pages/CheckoutPage';
export function App() {
  const path = window.location.pathname;
  if (path === '/checkout') {
    return <CheckoutPage data-id="element-0" />;
  }
  return <LandingPage data-id="element-1" />;
}